import React from 'react';
import { Lightbulb, Target, Cpu, CheckCircle } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { useLanguage } from '../i18n';

const AIProjectsPage = () => {
  const { t, getAIProjects } = useLanguage();
  const projects = getAIProjects();

  return (
    <Layout>
      <section className="py-12 lg:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="mb-12 lg:mb-16">
            <span className="label-mono mb-4 block">{t('aiProjects.label')}</span>
            <h1 className="section-title">{t('aiProjects.title')}</h1>
            <p className="font-body text-base text-slate-600 mt-4 max-w-3xl text-justify">
              {t('aiProjects.description')}
            </p>
          </div>

          <div className="space-y-8">
            {projects.map((project, index) => (
              <div 
                key={project.id} 
                className="bg-white border border-slate-200 p-6 lg:p-8"
              >
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-50 text-blue-600 flex-shrink-0">
                    <span className="font-mono text-sm font-medium">{String(index + 1).padStart(2, '0')}</span>
                  </div>
                  <h2 className="font-display text-xl lg:text-2xl font-medium text-slate-800">
                    {project.title}
                  </h2>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {/* Contexte */}
                  <div className="space-y-3">
                    <div className="flex items-center gap-2">
                      <Lightbulb className="w-4 h-4 text-amber-500" />
                      <h3 className="font-mono text-xs uppercase tracking-wider text-slate-500">
                        {t('aiProjects.context')}
                      </h3>
                    </div>
                    <p className="font-body text-sm text-slate-600 leading-relaxed text-justify">
                      {project.context}
                    </p>
                  </div>

                  {/* Approche */}
                  <div className="space-y-3">
                    <div className="flex items-center gap-2">
                      <Target className="w-4 h-4 text-blue-500" />
                      <h3 className="font-mono text-xs uppercase tracking-wider text-slate-500">
                        {t('aiProjects.approach')}
                      </h3>
                    </div>
                    <p className="font-body text-sm text-slate-600 leading-relaxed text-justify">
                      {project.approach}
                    </p>
                  </div>

                  {/* Rôle de l'IA */}
                  <div className="space-y-3">
                    <div className="flex items-center gap-2">
                      <Cpu className="w-4 h-4 text-purple-500" />
                      <h3 className="font-mono text-xs uppercase tracking-wider text-slate-500">
                        {t('aiProjects.aiRole')}
                      </h3>
                    </div>
                    <p className="font-body text-sm text-slate-600 leading-relaxed text-justify">
                      {project.aiRole}
                    </p>
                  </div>

                  {/* Résultat */}
                  <div className="space-y-3">
                    <div className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-emerald-500" />
                      <h3 className="font-mono text-xs uppercase tracking-wider text-slate-500">
                        {t('aiProjects.result')}
                      </h3>
                    </div>
                    <p className="font-body text-sm text-slate-600 leading-relaxed text-justify">
                      {project.result}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AIProjectsPage;
